<script>
  import { createEventDispatcher } from "svelte";
  import { navigateTo } from "svelte-router-spa";
  import { Link, TextField, SelectField } from "@saztrek/firefly";
  import { MANUFACTURERS } from "../../../../gql";

  import CRUDPage from "../../../components/CRUDPage.svelte";
  import { selectOptions } from "../../../components/defaultObjects";

  const dispatch = createEventDispatcher();

  const columns = [
    {
      field: "code",
      name: "Code",
      renderComponent: Link,
      resolveProps: (data) => {
        return {
          href: `manufacturers/edit/${data.code}`
        };
      }
    },
    {
      field: "name",
      name: "Name",
      dataType: "string"
    }
  ];

  const tableActions = [
    {
      icon: "pencil",
      title: "Edit",
      action: (data) => {
        navigateTo(`manufacturers/edit/${data.code}`);
      }
    },
    {
      icon: "trash",
      title: "Inactivate",
      action: (data) => {
        dispatch("inactivateManufacturer", { code: data.code });
      }
    }
  ];

  const findObjectInput = {
    findManufacturerInput: {
      code: undefined,
      name: undefined,
      version: undefined
    }
  };

  let code;
  let name;
  let isActiveList;

  const resetSearch = () => {
    code = "";
    name = "";

    return {
      findManufacturerInput: {
        code: undefined,
        name: undefined
      }
    };
  };

  const updateSearch = () => {
    return {
      findManufacturerInput: {
        code: code !== "" ? code : undefined,
        name: name !== "" ? name : undefined
      }
    };
  };

  const goToAddAccount = () => {
    navigateTo("manufacturers/new");
  };

  const processResponse = (response) => {
    const processEdges = (edges) => {
      return edges.map((edge) => {
        const { node } = edge;
        return {
          code: node.code,
          name: node.name
        };
      });
    };

    const { data } = response;
    const { manufacturers } = data;
    const { edges } = manufacturers;

    return {
      items: processEdges(edges),
      currentData: manufacturers
    };
  };
</script>

<div class="w-full px-10">
  <CRUDPage
    gqlQuery={MANUFACTURERS}
    {columns}
    {tableActions}
    {processResponse}
    {findObjectInput}
    {resetSearch}
    {updateSearch}
    goToAdd={goToAddAccount}>
    <div slot="searchform" class="w-full grid grid-cols-1 md:grid-cols-3 gap-2">
      <TextField type="search" placeholder="Code" bind:textValue={code} />
      <TextField type="search" placeholder="Name" bind:textValue={name} />
      <SelectField options={selectOptions} bind:value={isActiveList} />
    </div>
  </CRUDPage>
</div>
